import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useRef, useState, useEffect } from 'react';
import useStyles from './styles';
import { useTheme } from 'react-jss';
import clsx from 'clsx';

var Icon = function Icon(_a) {
  var _clsx;

  var name = _a.name,
      height = _a.height,
      width = _a.width,
      _a$color = _a.color,
      color = _a$color === void 0 ? null : _a$color,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'regular' : _a$variant,
      _a$onClick = _a.onClick,
      onClick = _a$onClick === void 0 ? null : _a$onClick,
      _a$customClassName = _a.customClassName,
      customClassName = _a$customClassName === void 0 ? '' : _a$customClassName,
      _a$inlineStyles = _a.inlineStyles,
      inlineStyles = _a$inlineStyles === void 0 ? {} : _a$inlineStyles,
      _a$innerRef = _a.innerRef,
      innerRef = _a$innerRef === void 0 ? null : _a$innerRef,
      fill = _a.fill,
      rest = __rest(_a, ["name", "height", "width", "color", "disabled", "variant", "onClick", "customClassName", "inlineStyles", "innerRef", "fill"]);

  var ref = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMounted = _useState2[0],
      setMounted = _useState2[1];

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  var iconStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, classes[color], !disabled && color), _defineProperty(_clsx, classes.colorDefault, variant === 'contrast' && !disabled && !color), _defineProperty(_clsx, classes.disabled, disabled), _defineProperty(_clsx, classes["".concat(color, "_contrast")], !disabled && variant === 'contrast'), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _defineProperty(_clsx, classes.clickable, !!onClick), _clsx));
  useEffect(function () {
    var lazyIcon = function lazyIcon() {
      //Forçando uma re-renderização para sincronizar a ref atual (ref.current) com props.name
      setMounted(false);
      import("./icons/".concat(name, ".js")).then(function (module) {
        //Atribuindo novo módulo à ref atual (Será atualizado no fim da execução do efeito)
        ref.current = module[name];
        /*
            Necessário porque React ignora atualizações de estado repetidas.
            https://reactjs.org/docs/hooks-reference.html#bailing-out-of-a-state-update
        */

        setMounted(true);
      }); //todo: mensagens de erro personalizadas
    };

    lazyIcon();
  }, [name]);
  if (!isMounted) return null;
  var IconComponent = ref.current;
  return React.createElement("a", {
    className: iconStyle,
    onClick: onClick ? onClick : function () {},
    style: inlineStyles,
    ref: innerRef
  }, React.createElement(IconComponent, Object.assign({
    height: height === null || height === void 0 ? void 0 : height.toString(),
    width: width === null || width === void 0 ? void 0 : width.toString(),
    fill: fill
  }, rest)));
};

export { Icon };